import axios from '@/utils/api'

const state = {
}

const getters = {
}

const actions = {
  async regerar ({ commit }, idsProcessos) {
    const data = await axios({
      method: 'post',
      data: idsProcessos,
      url: 'filaAutomatizada/regerarAnaliseAutomatizada'
    })
    return data
  },
  async retirarProcessoDaFila ({ commit }, idsProcessos) {
    const data = await axios({
      method: 'post',
      data: idsProcessos,
      url: 'filaAutomatizada/retirarProcessoDaFila'
    })
    return data
  }
}

const mutations = {
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/fila/filaAnaliseAutomatizada.js